module.exports = __webpack_public_path__ + "static/8-cd6e0015f7290b4c8bc75f5c6dc7173f.jpeg";